import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { AXIS_TEXT, GRID, SERIES } from "../theme";
import { Breakdown } from "../types";
import { Empty } from "./Card";

/** One horizontal bar per category, in the order given (the AL sorts by count). */
export default function BreakdownBars({ rows, label = (k) => (k === null ? "none" : String(k)) }: {
  rows: Breakdown[]; label?: (key: Breakdown["key"]) => string;
}) {
  if (rows.length === 0) return <Empty />;
  const data = rows.map((r) => ({ name: label(r.key), count: r.count }));
  const tick = { fill: AXIS_TEXT, fontSize: 12 };
  return (
    <ResponsiveContainer width="100%" height={Math.max(120, data.length * 32 + 32)}>
      <BarChart data={data} layout="vertical" margin={{ top: 0, right: 32, bottom: 0, left: 8 }}>
        <CartesianGrid stroke={GRID} horizontal={false} />
        <XAxis type="number" allowDecimals={false} tick={tick} stroke={GRID} />
        <YAxis type="category" dataKey="name" width={110} tick={tick} stroke={GRID} />
        <Tooltip itemStyle={{ color: AXIS_TEXT }} />
        <Bar
          dataKey="count" name="Count" fill={SERIES[0]} radius={[0, 4, 4, 0]} barSize={16}
          isAnimationActive={false} label={{ position: "right", fill: AXIS_TEXT, fontSize: 12 }}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
